import React from 'react';

/**
 * Horizontal bar chart showing readiness per domain, weighted by exam percentage.
 * Pure CSS — no Recharts needed for this simple visualization.
 */
export default function DomainReadinessBars({ domainReadiness }) {
  return (
    <div className="bg-gray-800/50 border border-gray-700/50 rounded-xl p-6">
      <h3 className="text-sm font-medium text-gray-400 uppercase tracking-wider mb-4">Domain Readiness</h3>
      <div className="space-y-3">
        {domainReadiness.map(dr => (
          <div key={dr.domainId} className="flex items-center gap-3">
            <div className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: dr.color }} />
            <span className="text-sm text-gray-300 w-36 truncate">{dr.name}</span>
            <div className="flex-1 relative">
              {/* Background bar */}
              <div className="w-full bg-gray-700 rounded-full h-4">
                {/* Readiness fill */}
                <div
                  className="h-4 rounded-full transition-all duration-500"
                  style={{
                    width: `${Math.min(100, dr.readiness)}%`,
                    backgroundColor: dr.readiness >= 70 ? '#2ECC71' : dr.readiness >= 40 ? '#F39C12' : '#E74C3C',
                  }}
                />
              </div>
              {/* Exam weight marker */}
              <div
                className="absolute top-0 h-4 border-r-2 border-white/30"
                style={{ left: `${dr.weight * 100 * 3}%` }}
                title={`Exam weight: ${Math.round(dr.weight * 100)}%`}
              />
            </div>
            <span className="text-sm font-medium text-gray-300 w-12 text-right">{dr.readiness}%</span>
            <span className="text-xs text-gray-500 w-8 text-right">{Math.round(dr.weight * 100)}%</span>
          </div>
        ))}
      </div>
      <div className="text-xs text-gray-600 mt-3">
        Bars show readiness (accuracy x coverage). Right column shows exam weight.
      </div>
    </div>
  );
}
